import type { MessageConversationResponseType } from "@sellar-io/api-v2/types";
import { useEffect, useRef } from "react";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useMessageMarkRead } from "./useMessageMarkRead";

export const useMessageThreadRead = (
  relationshipId: number,
  readCursor: MessageConversationResponseType["readCursor"],
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const { mutate } = useMessageMarkRead();
  const acknowledged = useRef<string | null>(null);
  const key = `${user?.uid}:${business?.id}:${relationshipId}:${readCursor}`;
  useEffect(() => {
    const acknowledge = () => {
      if (
        !readCursor ||
        document.visibilityState !== "visible" ||
        acknowledged.current === key
      ) {
        return;
      }
      acknowledged.current = key;
      mutate(
        { kind: "conversation", messageId: readCursor },
        {
          onError: () => {
            if (acknowledged.current === key) {
              acknowledged.current = null;
            }
          },
        },
      );
    };
    acknowledge();
    document.addEventListener("visibilitychange", acknowledge);
    window.addEventListener("focus", acknowledge);
    return () => {
      document.removeEventListener("visibilitychange", acknowledge);
      window.removeEventListener("focus", acknowledge);
    };
  }, [readCursor, key, mutate]);
};
